/** Pasta no Firebase Storage para capas da vitrine de produtos. */
export const CATALOG_PRODUCT_IMAGE_STORAGE_DIR = 'products';

export function sanitizeCatalogProductImageFileName(fileName = 'image') {
  return String(fileName)
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9._-]/g, '');
}

export function buildCatalogProductImageStoragePath(fileName, idGenerator) {
  const uniqueId = typeof idGenerator === 'function' ? idGenerator() : `${Date.now()}`;
  const sanitized = sanitizeCatalogProductImageFileName(fileName);
  return `${CATALOG_PRODUCT_IMAGE_STORAGE_DIR}/${uniqueId}_${sanitized}`;
}

/** Extrai bucket + path interno a partir de URLs do Firebase/Google Cloud Storage. */
export function getStorageLocationFromUrl(imageUrl) {
  if (!imageUrl || typeof imageUrl !== 'string') return null;

  try {
    const url = new URL(imageUrl);

    if (url.hostname.includes('firebasestorage.googleapis.com')) {
      const bucketMatch = url.pathname.match(/\/b\/([^/]+)\/o\//);
      const encodedPath = url.pathname.split('/o/')[1];
      if (!bucketMatch || !encodedPath) return null;

      return {
        bucket: decodeURIComponent(bucketMatch[1]),
        path: decodeURIComponent(encodedPath.split('?')[0]),
        token: url.searchParams.get('token'),
      };
    }

    if (url.hostname === 'storage.googleapis.com') {
      const match = url.pathname.match(/\/download\/storage\/v1\/b\/([^/]+)\/o\/(.+)$/);
      if (!match) return null;

      return {
        bucket: decodeURIComponent(match[1]),
        path: decodeURIComponent(match[2]),
        token: url.searchParams.get('token'),
      };
    }
  } catch {
    return null;
  }

  return null;
}

/** Extrai o path interno do bucket a partir de uma download URL do Firebase Storage. */
export function getStoragePathFromDownloadUrl(downloadUrl) {
  return getStorageLocationFromUrl(downloadUrl)?.path ?? null;
}

export function isFirebaseStorageDownloadUrl(downloadUrl) {
  return !!getStorageLocationFromUrl(downloadUrl);
}

/**
 * Converte URLs de download do Storage (disparam save no navegador) em URLs
 * visualizáveis inline (?alt=media) para prompts de IA e preview no browser.
 */
export function toViewableImageUrl(imageUrl) {
  if (!imageUrl || typeof imageUrl !== 'string') return imageUrl;

  try {
    const parsed = new URL(imageUrl);

    if (
      parsed.hostname.includes('firebasestorage.googleapis.com') &&
      parsed.searchParams.get('alt') === 'media' &&
      !parsed.pathname.includes('/download/')
    ) {
      return imageUrl;
    }

    const location = getStorageLocationFromUrl(imageUrl);
    if (!location) return imageUrl;

    const viewUrl = new URL(
      `https://firebasestorage.googleapis.com/v0/b/${location.bucket}/o/${encodeURIComponent(location.path)}`
    );
    viewUrl.searchParams.set('alt', 'media');
    if (location.token) {
      viewUrl.searchParams.set('token', location.token);
    }

    return viewUrl.toString();
  } catch {
    return imageUrl;
  }
}
